import styled from 'styled-components';
import { Label } from 'common/baseComponents'
import { SIZE, LAYERS } from 'common/sizes';

import { LABEL, LIST } from 'common/base';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IStyleProps {
    bgColor: string;
    firstWidget: boolean;
    lastWidget: boolean;
}
  
interface ISeparatorStyleProps {
    selectedTab: string;
}

export const MainContainer = styled.div`
    padding: 20px 0px 40px 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const MovilContainer = styled.div`
    width: 435px;
    padding: 0px 0px 0px 0px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
    background-color: #fff;
    border-radius: 40px;
`;

export const WidgetContainer = styled.div`
    position: relative;
    margin: 0px 0px 0px 0px;
    padding: 50px 42px 50px 42px;
    background-color: ${(props: IStyleProps) => (props.bgColor)};
    border-radius: ${(props: IStyleProps) => (props.firstWidget ? '40px 40px 0px 0px' : (props.lastWidget ? '0px 0px 40px 40px' : '0px 0px 0px 0px' ))};
`;

export const SeparatorContainer = styled.div`
    display: ${(props: ISeparatorStyleProps) => (props.selectedTab === "entire" ? 'none' : '')};
    padding: 0px 40px 0px 40px;
`;

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(189, 189, 189, 0.5);
`;
